import { Question, Questionnaire } from '../../type'

export function transformPayload(
    originalPayload: any,
    resourceId: string,
    questionnaireId: string
): Questionnaire {
    const transformedQuestions: Question[] = originalPayload.questions.map(
        (question: any) => {
            const questionOptions: string[] = question.questionOptions.map(
                (option: any) => option.text
            )
            return {
                questionnaireId: question.questionnaireId
                    ? question.questionnaireId
                    : questionnaireId
                      ? questionnaireId
                      : null,
                questionId: question.questionId ? question.questionId : null,
                questionTitle: question.questionTitle,
                questionOptions: questionOptions,
                correctAnswer: question.correctAnswer,
            }
        }
    )

    const transformedPayload: Questionnaire = {
        resourceId: resourceId,
        questionnaireId: questionnaireId ? questionnaireId : null,
        questionnaireTitle: originalPayload.questionnaireTitle,
        passingScore: originalPayload.passingScore,
        questions: transformedQuestions,
    }

    return transformedPayload
}
